module.exports = __webpack_public_path__ + "media/assets/images/linkedin-logo-black-2eda7bddaacee15c44494bb63ca94165.svg";